module.exports = "/assets/career/team/albert_ligor.png?IffTpc+";